<template lang="pug">
  #About
    #About_header(:class="{'About_header_t': device === 'tablet'}")
      template(v-if="device === 'mobile'")
        p {{ $t('敏捷高效的团队') }}
        p(style="margin-bottom: 110px") {{ $t('打造激动人心的产品') }}
      template(v-else)
        p(style="margin-bottom: 110px") {{ $t('敏捷高效的团队打造激动人心的产品') }}
      .aboutus
        .aboutus_title {{$t('关于我们')}}
          .aboutus_title_bg ABOUT
        .aboutus_detail
          .span {{$t('上海复歌信息科技有限公司是一家成立10年的营销技术公司。通过连接数据、媒体和工具，使得广告代理商和广告主可以进行高效、深入、透明的市场营销活动，借助对营销的思考和技术的力量，推动行业发展。目前，复歌已完成400万元的天使投资及2,000万元的A轮投资。')}}
          .span(style="margin-top: 10px") {{$t('复歌在数字化管理、供应商市场、红人营销、广告金融、资源直采等核心产品与服务已经为超过10家广告代理公司、近260个品牌广告主提供过服务，主要客户包含：联合利华、欧莱雅、滴滴出行、拜耳、维京游轮、阳狮集团，电通安吉斯，群邑等。')}}
    #about_product
      .about_product_content
        .about_product_title_en PRODUCT
        .about_product_title_ch 关于产品
        .about_product_detail
          p {{$t('“让广告技术美而温暖”是复歌的产品理念。')}}
          p {{$t('在努力为企业客户创造价值的同时，也希望让使用复歌产品的每个人都能感受到技术的温度。')}}
          p {{$t('我们关注用户的体验和建议，我们期待我们的产品能够给每个使用者的工作和生活带来正面的改变。')}}
          p {{$t('我们崇尚技术，用科技的力量使工作变得简单，使生活变得更加美好而优雅，是我们的愿景。')}}
      .about_product_bg
        img(src="@/assets/about/about_production.png")
    #about_team
      .about_team_content
        .about_team_title_en CULTURE
        .about_team_title_ch 企业文化
        .about_team_detail
          p {{$t('复歌是一个非常年轻的团队，公司大部分成员是90后。')}}
          p {{$t('工作上，专业、注重细节、拥抱创新、快速试错。')}}
          p {{$t('协作中，开放、坦诚、包容、还有一点点举重若轻的幽默感。')}}
          p {{$t('以上这些都是复歌团队的重要特质。')}}
          p {{$t('在复歌，每个人可以平等地表达自己的观点和意见，每个人的想法和意愿都会被尊重。')}}
          p {{$t('如果你有理想，并拥有被理想所驱使的自我驱动力，我们期待你的加入。')}}
      .about_team_bg
        img(src="@/assets/about/about_team.png")
    #Time_axis__container
      #Time_axis
        .time_line.time_line_2009
          .time_line_title 2009.9
          .time_line_detail {{ $t('成立于上海') }}
          img.time_line_bottom(src="@/assets/about/time_line.png")
        .time_line.time_line_2013
          img.time_line_top(src="@/assets/about/time_line.png")
          .time_line_title 2013.6
          .time_line_detail 发布首款产品<br>搜索引擎广告管理工具Bid Agent<br>欧莱雅 & LVMH
        .time_line.time_line_2015
          .time_line_title 2015.5
          .time_line_detail 发布Agency Trading Desk<br>阳狮集团 & 电通安吉斯集团
          img.time_line_top(src="@/assets/about/time_line.png")
        .time_line.time_line_2017
          img.time_line_top(src="@/assets/about/time_line.png")
          .time_line_title 2017.2
          .time_line_detail 完成天使轮和A轮融资<br>共计2,400万元
        .time_line.time_line_2018
          .time_line_title 2018.6
          .time_line_detail 发布营销投资管理平台<br>联合利华 & 滴滴出行
          img.time_line_top(src="@/assets/about/time_line.png")
        .time_line.time_line_2019
          img.time_line_top(src="@/assets/about/time_line.png")
          .time_line_title 2019.5
          .time_line_detail 发布国内首个营销资源开放平台<br>“贵了么”
        .time_line.time_line_2019_1
          .time_line_title 2019.10
          .time_line_detail 发布营销人才服务平台<br>“好快活”
          img.time_line_bottom(src="@/assets/about/time_line.png")
    #news
      .news_title
        .news_title_ch 相关新闻
      .news_swiper
        .news_card(
          v-for="(item ,i) in news"
          :key="i"
        )
          a(:href="item.url" target="_blank") {{ $t(item.content) }}
        div(style="width:1px;height:78px;padding-left:18px")
    about-team
    contact
</template>

<script>
import MobileContact from '@/components/MobileContact'
import AboutTeam from '@/components/MobileAboutTeam/index'
export default {
  components: {
    Contact: MobileContact,
    AboutTeam
  },
  data () {
    return {
      news: [
        // {
        //   content: '未来对营销行业有革新性、颠覆性的技术，长什么样？',
        //   url: 'http://www.ad-cn.net/read/10036.html'
        // },
        {
          content: '让营销供应链高效，复歌科技推出营销资源平台“贵了么”',
          url: 'https://36kr.com/p/5230457'
        },
        {
          content: 'Is it expensive?: Sellers not pleased by price-comparison tool for China digital ads.',
          url: 'https://www.campaignasia.com/article/is-it-expensive-sellers-not-pleased-by-price-comparison-tool-for-china-digita/451675'
        },
        {
          content: 'Realign Incentive Systems in Media Trading Supply Chains.',
          url: 'https://mp.weixin.qq.com/s/lxRRTomvHDyjXmNdRn6gqA'
        }
      ],
      device: this.$device
    }
  }
}
</script>

<style lang="stylus">
#About_header
  width 100%
  height 435px
  position relative
  display flex
  flex-direction column
  justify-content center
  align-items center
  margin-bottom 342px
  background url('../../../assets/about/header_bg_m.jpg') no-repeat center
  background-size cover
  color #fff
  &> p
    font-size 36px
    font-weight 500
    text-align center
  .aboutus
    background-color #fff
    position absolute
    left 24px
    right 24px
    top 281px
    border-radius 30px
    padding 42px 24px
    box-sizing border-box
    box-shadow: 0 0 20px 0 rgba(176, 176, 176, 0.5)
    .aboutus_title
      margin 0 auto 26px
      font-size 36px
      color #4B8ECB
      font-weight 200
      height 56px
      display flex
      justify-content center
      align-items flex-end
      position relative
      .aboutus_title_bg
        position absolute
        font-weight normal
        top 0
        left 0
        right 0
        bottom 0
        z-index 0
        color rgba(71, 139, 202, 0.1)
        font-size 56px
        line-height 65px
        text-align center
    .aboutus_detail
      text-align left
      font-size 14px
      line-height 1.5
      color rgba(48, 50, 81, 0.7)
#About_header.About_header_t
  background url('../../../assets/about/header_bg_t.jpg') no-repeat center
#about_product
  margin-bottom 90px
  padding 0 24px
  .about_product_content
    padding-top 90px
    box-sizing border-box
    height 100%
    .about_product_title_en, .about_product_title_ch
      font-size 32px
      font-weight 500
      color #3fb4e1
      margin-bottom 16px
    .about_product_detail
      padding-top 24px
      color rgba(48, 50, 81, 0.7)
      font-size 14px
      line-height 1.7
  .about_product_bg
    margin-top 24px
    width 100%
    img
      width 100%
#about_team
  margin-bottom 120px
  padding 0 24px
  position relative
  .about_team_bg
    margin-top 24px
    width 100%
    img
      width 100%
  .about_team_content
    box-sizing border-box
    .about_team_title_en, .about_team_title_ch
      font-size 32px
      font-weight 500
      color #3fb4e1
      margin-bottom 16px
    .about_team_detail
      padding-top 24px
      color rgba(48, 50, 81, 0.7)
      font-size 14px
      line-height 1.7
#Time_axis__container::-webkit-scrollbar {
  display none
}
#Time_axis__container
  width 100vw
  height 400px
  overflow-x scroll
  #Time_axis
    height 100%
    width 800px
    background url('../../../assets/about/time_axis.png') no-repeat center
    background-size 100% 200px
    position relative
    .time_line
      position absolute
      max-width 432px
      display flex
      flex-direction column
      align-items center
      .time_line_title
        color #3fb4e1
        font-size 25px
        font-weight 500
        margin-bottom 8px
        margin-right auto
      .time_line_detail
        text-align left
        color #6e6f85
        line-height 1.5
        font-size 13px
      .time_line_bottom
        margin-top 13px
        height 70px
      .time_line_top
        margin-top 13px
        height 70px
    .time_line_2009
      left 4%
      top 15%
    .time_line_2013
      left 5%
      bottom 0
      img
        transform rotate(180deg)
    .time_line_2015
      left 20%
      top 12%
    .time_line_2017
      left 40%
      bottom 5%
      img
        transform rotate(180deg)
    .time_line_2018
      left 55%
      top 0%
    .time_line_2019
      bottom 15%
      left 70%
      img
        transform rotate(180deg)
    .time_line_2019_1
      top 20px
      left 82%
#news
  width 100%
  height 150px
  box-sizing border-box
  margin 90px 0
  .news_title
    padding-left 24px
    color #3fb4e1
    font-size 32px
    font-weight 500
    margin-bottom 24px
  .news_swiper::-webkit-scrollbar {
    display none
  }
  .news_swiper
    display flex
    width 100vw
    overflow-x scroll
    padding-left 14px
    box-sizing border-box
    .news_card
      margin 15px 10px
      box-shadow 0 0 20px 0 rgba(54, 65, 80, 0.1)
      width 244px
      height 78px
      display flex
      justify-content center
      align-items center
      background url('../../../assets/about/news_bg.png') no-repeat center
      background-size 100%
      color #4b8ecb
      a
        width 210px
        padding 0 25px
        font-size 14px
        line-height 1.5
        text-decoration none
      a:hover
        text-decoration underline
@media (min-width: 765px) and (max-width: 1275px)
  #About_header
    margin-bottom 265px
    .aboutus
      left 72px
      right 72px
      padding 56px 30px
      .aboutus_detail
        font-size 16px
  #about_product
    padding 0 72px
    .about_product_content
      padding-top 0
      .about_product_detail
        font-size 16px
    .about_product_bg
      text-align center
      img
        width 327px
  #about_team
    padding 0 72px
    .about_team_content
      .about_team_detail
        font-size 16px
    .about_team_bg
      width 100%
      text-align center
      img
        width 327px
  #Time_axis__container #Time_axis
    width 100vw
  #news
    .news_title
      padding-left 72px
    .news_swiper
      padding-left 63px
      .news_card
        margin 15px 9px
</style>
